import {
  type DocumentGenType,
  DocumentGenType as DocumentGenTypeValue,
} from '@heidi/schema/ml-scribe';

export const DOCUMENT_GENERATION_TYPES = new Set<DocumentGenType>([
  DocumentGenTypeValue.TEMPLATE,
  DocumentGenTypeValue.INTERNAL_TEMPLATE,
  DocumentGenTypeValue.PRESET_AI_COMMAND,
  DocumentGenTypeValue.ASK_AI,
  DocumentGenTypeValue.GPCCMP,
  DocumentGenTypeValue.PDF,
]);
